import { Nullable, PagableParams } from '../../../types';

export enum ECashbackEligibility {
  EVERY_TRANSACTION = 'EVERY_TRANSACTION',
  FIRST_TRANSACTION = 'FIRST_TRANSACTION'
}

export enum ECampaignStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  DEACTIVATED = 'DEACTIVATED'
}

export enum ECashbackType {
  PERCENTAGE = 'PERCENTAGE',
  AMOUNT = 'AMOUNT'
}

export const CASHBACK_TYPE_TRANSLATIONS = Object.freeze({
  [ECashbackType.PERCENTAGE]: 'general.percentage',
  [ECashbackType.AMOUNT]: 'general.amount'
});

export const CAMPAIGN_ELIGIBILITY_TRANSLATIONS = Object.freeze({
  [ECashbackEligibility.EVERY_TRANSACTION]: 'affiliateCampagin.everyTransaction',
  [ECashbackEligibility.FIRST_TRANSACTION]: 'affiliateCampagin.firstTransaction'
});

export const CAMPAIGN_STATUS_TRANSLATIONS = Object.freeze({
  [ECampaignStatus.ACTIVE]: 'general.active',
  [ECampaignStatus.DRAFT]: 'general.draft',
  [ECampaignStatus.DEACTIVATED]: 'general.deactivated'
});

export interface PaginatedCampaignParams extends PagableParams {
  businessProfileId: number;
  from?: Nullable<string>;
  to?: Nullable<string>;
  locationIds?: Nullable<number[]>;
}

export interface Campaign {
  id: number;
  ongoing: boolean;
  cashbackEligibility: ECashbackEligibility;
  description: Nullable<Record<string, string>>;
  name: Nullable<Record<string, string>>;
  status: ECampaignStatus;
  startDateTime: string;
  endDateTime: string;
  businessProfileId: number;
  businessProfileName?: string;
  locationIds: number[];
  commissionIds: number[];
  cashbackValue: number;
  cashbackType: ECashbackType;
}

export type CreateCampaignBody = Partial<Campaign>;

export type UpdateCampaignBody = Partial<Campaign>;
